/**
 * Simplified Slippage Warning
 * Only shows when tolerance needs to be adjusted - clean and minimal
 */

import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { formatTolerancePercent } from "./slippage-config";
import type { SlippageEstimation } from "./use-slippage-estimation";

interface SlippageWarningProps {
  estimation: SlippageEstimation;
  onAcceptAndContinue: () => void;
}

export const SlippageWarning = ({
  estimation,
  onAcceptAndContinue,
}: SlippageWarningProps) => {
  // Only show when tolerance is exceeded
  if (!estimation.exceedsTolerance || !estimation.hasVlpData) {
    return null;
  }

  return (
    <div className="p-3 bg-destructive/10 border border-destructive/20 rounded-lg space-y-2">
      <div className="flex items-start gap-2">
        <AlertTriangle className="h-4 w-4 text-destructive flex-shrink-0 mt-0.5" />
        <p className="text-sm text-destructive">
          This order requires{" "}
          <span className="font-semibold">
            {formatTolerancePercent(estimation.suggestedTolerance)}
          </span>{" "}
          slippage tolerance to execute.
        </p>
      </div>
      <Button
        onClick={onAcceptAndContinue}
        className="w-full"
        size="sm"
      >
        Increase Slippage to {formatTolerancePercent(estimation.suggestedTolerance)}
      </Button>
    </div>
  );
};
